import React from 'react'
import AuthLayout from '../../layout/AuthLayout'

const ConfirmPassword = () => {
    return (
        <AuthLayout>
            <div className='self-start tracking-wide w-full'>
                <img src={require('../../assets/logo.svg')} alt='logo' />
                <div className='mt-6'>
                    <h1 className='font-bold tracking-wide text-2xl'>Create new password</h1>
                </div>

                <div className='mt-10'>
                    <div>
                        <input type='text' placeholder='Password' />
                    </div>
                    <div className='mt-6'>
                        <input type='text' placeholder='Confirm Password' />
                    </div>
                    <div className='mt-8'>
                        <button className='w-full bg-green font-semibold text-white tracking-wide text-sm py-4 br-5'>
                            Send request password
                        </button>
                    </div>
                </div>
            </div>
        </AuthLayout>
    )
}

export default ConfirmPassword
